import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './layout/header/header.component';
import { PageLoaderComponent } from './layout/page-loader/page-loader.component';
import { LocationStrategy, HashLocationStrategy, DatePipe } from '@angular/common';
import { DynamicScriptLoaderService } from './shared/services/dynamic-script-loader.service';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NGX_ECHARTS_CONFIG } from 'ngx-echarts';
import { PermissionsModule } from '@shared/permissions/permissions.module';
import { ChatModule } from './chat/chat.module';
// Services
import { AuthService } from 'src/@core/services/auth.service';
import { AuthGuard } from 'src/@core/services/auth.guard';
import { HttpService } from 'src/@core/services/http.service';
import { AlertService } from 'src/@core/services/alert.service';
import { CanDeactivateGuard } from 'src/@core/services/can-deactivate-guard.service';
import { BuildVersionInterceptor } from './shared/interceptors/build-version.interceptor';
import { RateLimitInterceptor } from './shared/interceptors/rate-limit.interceptor';
import { IndicatorReportingTimeoutInterceptor } from './shared/interceptors/indicator-reporting-timeout.interceptor';
import { AuthRefreshInterceptor } from './shared/interceptors/auth-refresh.interceptor';
import { CommandPaletteComponent } from './shared/command-palette/command-palette.component';
// Core Module
import { CoreModule } from 'src/@core/core.module';

@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        PageLoaderComponent,
        CommandPaletteComponent,
    ],
    imports: [
        CoreModule,
        PermissionsModule,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        MatIconModule,
        MatButtonModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatDividerModule,
        MatProgressSpinnerModule,
        ChatModule,
    ],
    providers: [
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        DynamicScriptLoaderService,
        // Services
        AuthGuard,
        AuthService,
        HttpService,
        AlertService,
        CanDeactivateGuard,
        DatePipe,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthRefreshInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: BuildVersionInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RateLimitInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: IndicatorReportingTimeoutInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
        {
            provide: NGX_ECHARTS_CONFIG,
            useFactory: () => ({ echarts: () => import('echarts') }),
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule { }
